/**
 * ═══════════════════════════════════════════════════════════════
 *  CHAVES DE DISPONIBILIDADE DAS FORMAS DE PAGAMENTO
 * ═══════════════════════════════════════════════════════════════
 *
 *  PARA RELIGAR O PIX: troque `true` por `false` na constante
 *  PIX_DESATIVADO abaixo. Nada mais precisa ser alterado.
 *
 *  Com o PIX desativado:
 *    - a tela de fatura abre direto no cartão de crédito;
 *    - a lista de formas de pagamento fica sempre visível, em vez
 *      de escondida atrás do "Outras formas de pagamento";
 *    - o botão "Pagar com PIX" some.
 */

/** PIX avulso (QR Code / copia e cola) — desativado temporariamente. */
export const PIX_DESATIVADO = false;

/**
 * Pix automático (débito mensal autorizado no banco). É um fluxo
 * separado do PIX avulso e segue ativo. Troque para `true` caso
 * precise desativá-lo também.
 */
export const PIX_AUTOMATICO_DESATIVADO = false;

/** Aviso exibido ao cliente enquanto o PIX estiver desativado. */
export const PIX_AVISO =
  "Pagamentos por PIX estão temporariamente desativados para correção. Escolha uma das outras formas de pagamento abaixo.";

// ─── Derivados: use estes no restante do código ───
export const PIX_ATIVO = !PIX_DESATIVADO;
export const PIX_AUTOMATICO_ATIVO = !PIX_AUTOMATICO_DESATIVADO;

/** Forma de pagamento aberta por padrão: '0' = PIX, '2' = cartão de crédito. */
export const FORMA_PAGAMENTO_PADRAO = PIX_ATIVO ? "0" : "2";
